import { MDBBtn, MDBModal, MDBModalContent, MDBModalDialog } from 'mdb-react-ui-kit'
import React from 'react'
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showPopup } from '../../Containers/App/action';
import { selectProfile } from '../../Containers/Client/selector';
import useWindowDimensions from '../../Utils/customHooks/useWindowDimension';
import EditProfilePicture from '../EditProfilePicture';
import FormPostAdd from '../FormPostAdd';
import WalletList from '../WalletList';

function Modal({isOpen, content, profile}) {
    const contentEvent = {
        new_post: "add-post",
        wallet: "wallet-list",
        profile_pic: "edit-profile-picture"
    }
    const {width} = useWindowDimensions();
    const dispatch = useDispatch();
    const onClose = () => {
        dispatch(showPopup({isOpen: false}))
    }
    const getPopupContent = () => {
        if(content === contentEvent.new_post){
            return <FormPostAdd isModal={true} onClose={onClose} profilePicture={profile.profilePicture}/>;   
        }
        if(content === contentEvent.wallet){
            return (<WalletList username={profile.username}/>)
        }
        if(content === contentEvent.profile_pic){
            return <EditProfilePicture />
        }
    }
    const onWindowChange = (type) => {
        if(width<=992){
            if (type === "dialog")
                return 'fullscreen-lg-down';
        }
        if(content === contentEvent.wallet){
            return 'sm';
        }
        return 'lg';
    }
    return (
        <>
            <MDBModal staticBackdrop tabIndex='-1' show={isOpen} draggable={false} >
                <MDBModalDialog size={onWindowChange("dialog")} centered>
                    <MDBModalContent className='p-4 pe-4 ps-4'>
                        <div className='d-flex justify-content-end w-100'>
                            <MDBBtn
                            type='button'
                            className='btn-close' 
                            color='none'
                            onClick={onClose}
                            ></MDBBtn>
                        </div>
                        {getPopupContent()}
                </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>
    )
}
const mapStateToProps = createStructuredSelector({
    profile: selectProfile
});
export default connect(mapStateToProps)(Modal)